module.exports = __webpack_public_path__ + "static/travel-guru-4e217556c795f4c6024bb31febb30385.gif";